import { useEffect } from "react";

import PageSkeleton from "../components/PageSkeleton";

function SpecialOffers () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <PageSkeleton
            titleKey="pages.offers.title"
            descriptionKey="pages.offers.description"
            sections={[
                "pages.offers.sections.1",
                "pages.offers.sections.2",
                "pages.offers.sections.3",
                "pages.offers.sections.4",
                "pages.offers.sections.5",
                "pages.offers.sections.6",
            ]}
        />
    );
}

export default SpecialOffers;
